export default require(`./${process.env.NODE_ENV}.config.js`).default
